import Spacer from '@berlitz/spacer'
import React from 'react'
import { StyledSection } from './style'

const Section: React.FC<{ grayed?: boolean }> = ({ grayed, children }) => {
  return (
    <StyledSection grayed={grayed}>
      <Spacer size="sm">{children}</Spacer>
    </StyledSection>
  )
}

export default Section
